import * as React from 'react';
const ContextualLayerStyleOverride = /*#__PURE__*/React.createContext({
  styleOverride: {}
});
export default ContextualLayerStyleOverride;